import { designSystemColors } from '@klv/shared/styles/colors';

import type { IChartYTick } from './types';

const ChartYTick = ({ x, y, payload, backgroundColor, fontSizeClamp, fontWeight }: IChartYTick) => {
  const fill = backgroundColor === 'charcoal' ? designSystemColors.white : designSystemColors.charcoal;

  return (
    <g fontFamily='Sohne' fontSize={fontSizeClamp}>
      <text x={x} y={y} dx={-10} dy={6} textAnchor="end" fill={fill} style={{ fontWeight: fontWeight }}>
        {payload.value}
      </text>
    </g>
  );
};

export default ChartYTick;
